exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-2c269270] {\n  margin: 0 0 10px;\n  font-size: 16px;\n  font-weight: 700;\n}\n.title[data-v-2c269270]:before {\n  content: \"\";\n  width: 4px;\n  height: 16px;\n  display: inline-block;\n  background: #1089ff;\n  vertical-align: middle;\n}\n.f-1[data-v-2c269270] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  width: 0;\n}", ""]);

// exports
